import { startOfMonth, endOfMonth, isSameDay } from "date-fns";
import { store } from "../store";
import {
	OccupiedDay,
	patchOccupiedDay,
	patchAvailability,
	patchAvailabilitiesByRange,
	getOccupiedDaysByRange
} from "../api/occupied-days";
import {
	updateOccupiedDays,
	updateSingleOccupiedDay,
	deactivateTableLinkMode
} from "./store/app-actions";
import { setSnackbarMessage } from "./store/snackbar-actions";

export const saveTableLinkGroupsAndUpdateStore = async () => {
	const tempTableLinkGroups = store.getState().tempTableLinkGroups;
	let filteredTempTableLinkGroups;

	try {
		filteredTempTableLinkGroups = tempTableLinkGroups.filter(
			group => group.length > 1
		);
	} catch (e) {
		store.dispatch(
			setSnackbarMessage(
				"Tischverbindungen konnten nicht gespeichert werden!",
				"error"
			)
		);
		store.dispatch(deactivateTableLinkMode());

		return;
	}

	if (tempTableLinkGroups.length > filteredTempTableLinkGroups.length) {
		store.dispatch(
			setSnackbarMessage(
				"Eine Tischgruppe benötigt mindestens 2 Tische!",
				"warning"
			)
		);

		return;
	}

	try {
		const updatedOccupiedDay = await saveTableLinkGroups(
			filteredTempTableLinkGroups
		);

		store.dispatch(
			updateSingleOccupiedDay(updatedOccupiedDay.id, updatedOccupiedDay)
		);
		store.dispatch(deactivateTableLinkMode());
	} catch (e) {
		store.dispatch(
			setSnackbarMessage(
				"Tischverbindungen konnten nicht gespeichert werden!",
				"error"
			)
		);
		store.dispatch(deactivateTableLinkMode());
	}
};

export const saveTableLinkGroups = async (tableGroups: string[][]) => {
	const response: OccupiedDay = await patchOccupiedDay(
		store.getState().date,
		{
			linkedTables: tableGroups
		}
	);

	response.date = new Date(response.date);

	return response;
};

export const updateAvailabilitiesByRange = async (from: Date, to: Date, weekdays: string, isAvailable: boolean) => {
	const response: OccupiedDay[] = await patchAvailabilitiesByRange(from, to, weekdays, isAvailable);

	store.dispatch(updateOccupiedDays(response));
};

export const updateAvailability = async (date: Date, isAvailable: boolean) => {
	const response: OccupiedDay = await patchAvailability(date, isAvailable);

	store.dispatch(updateOccupiedDays([response]));
};

export const toggleAreaLockForSelectedDay = async (areaId: string) => {
	const areas = store.getState().areas;
	const selectedDay = store.getState().date;
	const selectedOccupiedDay = store.getState().occupiedDays.filter(day => {
		return isSameDay(day.date, selectedDay);
	})[0];
	
	let isLockdown = (selectedOccupiedDay && selectedOccupiedDay.lockdown);
	let lockedAreas = (selectedOccupiedDay && selectedOccupiedDay.lockedAreas) || [];

	if (isLockdown) {
		lockedAreas = (areas && areas.length > 0) ? areas.map(a => a.id) : [];
	}

	if (lockedAreas.indexOf(areaId) > -1) {
		lockedAreas = lockedAreas.filter(id => id !== areaId);
	} else {
		lockedAreas.push(areaId);
	}

	const response: OccupiedDay = await patchOccupiedDay(selectedDay, {
		lockedAreas
	});

	store.dispatch(updateOccupiedDays([response]));
};

export const getOccupiedDaysForMonthAndUpdateStore = async (
	dateInMonth: Date
) => {
	const from = startOfMonth(dateInMonth);
	const to = endOfMonth(dateInMonth);

	const occupiedDays = await getOccupiedDaysByRange(from, to);
	store.dispatch(updateOccupiedDays(occupiedDays));
};
